/**
 * Which workspace learnings the Create-project dialog shows, and how each one
 * is worded. Read-only: a learning is promoted by a human elsewhere (Briefs);
 * here it is only surfaced so the plan is started with it in view.
 *
 * The `claim` is shown exactly as stored — it already carries its measurement
 * method and first limitation (see `buildClaimText`). The confidence tier is
 * appended as stored, never upgraded or rephrased into a stronger word.
 */
import {
  type WorkspaceLearning,
  resolveWorkspaceLearningStatus,
} from '@/services/data/WorkspaceLearningService';

export const MAX_PLAN_LEARNINGS = 3;

export interface PlanLearningRow {
  id: string;
  claim: string;
  confidenceLabel: string;
}

export function selectPlanLearnings(
  learnings: readonly WorkspaceLearning[] | null | undefined,
  now = new Date(),
): PlanLearningRow[] {
  return (learnings ?? [])
    .filter((l) => resolveWorkspaceLearningStatus(l, now) === 'active' && l.claim.trim().length > 0)
    .slice(0, MAX_PLAN_LEARNINGS)
    .map((l) => ({
      id: l.id,
      claim: l.claim.trim(),
      confidenceLabel: `${l.confidenceTier} confidence`,
    }));
}
